import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import StaffLayout from './components/StaffLayout';
import MarketingLayout from './marketing/MarketingLayout';
import HomePage from './marketing/pages/HomePage';
import AboutUs from './marketing/pages/AboutUs';
import MeetTheTeam from './marketing/pages/MeetTheTeam';
import ReviewsTestimonials from './marketing/pages/ReviewsTestimonials';
import FAQ from './marketing/pages/FAQ';
import PersonalCare from './marketing/pages/PersonalCare';
import CompanionshipCare from './marketing/pages/CompanionshipCare';
import RespiteCare from './marketing/pages/RespiteCare';
import AlzheimersDementiaCare from './marketing/pages/AlzheimersDementiaCare';
import HospiceCare from './marketing/pages/HospiceCare';
import PostOperativeCare from './marketing/pages/PostOperativeCare';
import SpecialtyCare from './marketing/pages/SpecialtyCare';
import SpinalCordInjuryCare from './marketing/pages/SpinalCordInjuryCare';
import PrivacyPolicy from './marketing/pages/PrivacyPolicy';
import Terms from './marketing/pages/Terms';
import Cookie from './marketing/pages/Cookie';
import Contact from './pages/Contact';
import PositionDescription from './pages/PositionDescription';
import Sign from './pages/Sign';
import NotFound from './pages/NotFound';
import Login from './pages/staff/Login';
import Contracts from './pages/staff/Contracts';
import ContractDetail from './pages/staff/ContractDetail';
import Settings from './pages/staff/Settings';
import Deliveries from './pages/staff/Deliveries';
import Account from './pages/staff/Account';

const App = () => (
  <BrowserRouter>
    <Routes>
      {/* Public site — same pages and addresses as the previous site. */}
      <Route element={<MarketingLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/about/meet-the-team" element={<MeetTheTeam />} />
        <Route path="/about/reviews-testimonials" element={<ReviewsTestimonials />} />
        <Route path="/about/faq" element={<FAQ />} />
        <Route path="/services/personal-care" element={<PersonalCare />} />
        <Route path="/services/companionship-care" element={<CompanionshipCare />} />
        <Route path="/services/respite-care" element={<RespiteCare />} />
        <Route path="/services/alzheimers-dementia-care" element={<AlzheimersDementiaCare />} />
        <Route path="/services/hospice-care" element={<HospiceCare />} />
        <Route path="/services/post-operative-care" element={<PostOperativeCare />} />
        <Route path="/services/specialty-care" element={<SpecialtyCare />} />
        <Route path="/services/spinal-cord-injury-care" element={<SpinalCordInjuryCare />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<Terms />} />
        <Route path="/cookie-policy" element={<Cookie />} />
        {/* Schedule A — the contract and the signed-copy email link here. */}
        <Route path="/positions/personal-care-assistant" element={<PositionDescription />} />
        <Route path="*" element={<NotFound />} />
      </Route>

      {/* Candidate signing: its own minimal shell, reached from the Ivipass portal. */}
      <Route path="/sign/:reference" element={<Sign />} />

      <Route path="/staff/login" element={<Login />} />
      <Route path="/staff" element={<StaffLayout />}>
        <Route index element={<Navigate to="contracts" replace />} />
        <Route path="contracts" element={<Contracts />} />
        <Route path="contracts/:id" element={<ContractDetail />} />
        <Route path="settings" element={<Settings />} />
        <Route path="deliveries" element={<Deliveries />} />
        <Route path="account" element={<Account />} />
      </Route>
    </Routes>
  </BrowserRouter>
);

export default App;
